import moment from "moment";
import { Link } from "react-router-dom";

// Utility function to check if a value is "empty" (null, undefined, empty string, or empty array)
const isEmpty = (value) => {
  if (Array.isArray(value)) return value.length === 0;
  return value == null || value === "" || value === 0;
};

export function TableRow({ transaction, currency }) {
  // Check if the necessary data exists and is not empty
  if (
    isEmpty(transaction?.ITEM_DETAILS) ||
    isEmpty(transaction?.BILL_AMOUNT) ||
    isEmpty(transaction?.POINTS_EARNED)
  ) {
    return null; // Don't render the row if the data is missing or empty
  }

  return (
    <Link
      className="text-decoration-none bg-transparent"
      to={"/transactions/single/" + transaction?.BILLREF}
      state={transaction}
    >
      <div className="w-100 row px-0 border border-top-0 border-end-0 border-start-0 border-wafaa-grey-opacity-50 border-1 bg-table-body-history"  style={{marginInline: '.01rem 0rem'}}>
        <div className="text-center col-4 font-size-13 text-wafaa-dark-blue-2 bg-table-body-history px-0 py-2">
          {transaction?.ITEM_DETAILS?.length < 1
            ? ""
            : moment(transaction.ITEM_DETAILS[0]?.TRAN_DATE).format(
                "DD.MM.YYYY"
              )}
        </div>
        <div
          className={
            "text-center col-4 transition-0-5-ease font-size-13 text-wafaa-dark-blue-2 bg-table-body-history px-0 py-2 "
          }
        >
          {currency||"AED"} {transaction?.BILL_AMOUNT}
        </div>
        <div
          className={
            "text-center col-4 transition-0-5-ease font-size-13 text-wafaa-bright-green bg-table-body-history ps-0 pe-0 py-2 "
          }
        >
          {isEmpty(transaction?.POINTS_EARNED)
            ? 0
            : transaction?.POINTS_EARNED[0]?.POINTS_EARNED}
        </div>
      </div>
      {/* <div className="row px-3 py-2 border-bottom border-0 border-wafaa-grey-opacity-10 bg-transparent ">
        <div className="text-center col-4 font-size-13 text-wafaa-dark-blue-2 dark:text-wafaa-light-grey py-2">
          {transaction?.ITEM_DETAILS?.length < 1
            ? ""
            : moment(transaction.ITEM_DETAILS[0]?.TRAN_DATE).format(
                "DD.MM.YYYY"
              )}
        </div>
        <div className="text-center col-4 font-size-13 text-wafaa-dark-blue-2 dark:text-wafaa-light-grey py-2">
          AED {transaction?.BILL_AMOUNT}
        </div>
        <div className="text-center col-4 font-size-13 text-wafaa-bright-green dark:text-wafaa-bright-green-light py-2">
          {isEmpty(transaction?.POINTS_EARNED)
            ? 0
            : transaction?.POINTS_EARNED[0]?.POINTS_EARNED}
        </div>
      </div> */}
    </Link>
  );
}

export function TableRowRedemption({ transaction, currency }) {
  // Check if the necessary data exists and is not empty
  if (
    isEmpty(transaction?.REEDEM_DATE) ||
    isEmpty(transaction?.VALUE) ||
    isEmpty(transaction?.POINTS_REDEMEED)
  ) {
    return null; // Don't render the row if the data is missing or empty
  }

  return (
    <Link
      className="text-decoration-none bg-transparent"
      to={"/transactions/single/redemption/" + transaction?.BILLREF}
    >
      <div className="w-100 row px-0 border border-top-0 border-end-0 border-start-0 border-wafaa-grey-opacity-50 border-1 bg-table-body-history"  style={{marginInline: '.01rem 0rem'}}>
        <div className="text-center col-4 font-size-13 text-wafaa-dark-blue-2 bg-transparent px-0 py-2">
          {transaction?.REEDEM_DATE
            ? moment(transaction?.REEDEM_DATE).format("DD.MM.YYYY")
            : ""}
        </div>
        <div
          className={
            "text-center col-4 transition-0-5-ease font-size-13 text-wafaa-dark-blue-2 bg-transparent px-0 py-2 "
          }
        >
          {currency||"AED"} {transaction?.VALUE}
        </div>
        <div
          className={
            "text-center col-4 transition-0-5-ease font-size-13 text-wafaa-bright-green bg-transparent ps-0 pe-3 py-2 "
          }
        >
          {transaction?.POINTS_REDEMEED ? transaction?.POINTS_REDEMEED : ""}
        </div>
      </div>
    </Link>
  );
}
